import {AntibodyEnforcedSchemaSpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {getShouldAddNamingStrategies} from 'antibodies/schema-configuration/schema-migration/schemaMigrationNamingStrategies';
import {RegistryLabelingStrategy} from 'constants/RegistryConstants';

/**
 * Whether applying this spec would actually change the schema's data model.
 *
 * A naming-strategy spec's strategies are alternatives (matching the backend contract), so the spec
 * is already satisfied — and counts as a no-op — as soon as the schema has any one of them; it only
 * counts as a change when the schema has none of them. `existingNamingStrategies` defaults to `null`
 * (treated as "no strategies applied yet"), so callers that only have the spec keep the conservative
 * behaviour of counting any naming-strategy spec as a change.
 */
export default function hasEnforcedDataModelChanges(
  enforcedSchemaSpec: AntibodyEnforcedSchemaSpec,
  existingNamingStrategies: Array<RegistryLabelingStrategy> | null = null
): boolean {
  return (
    enforcedSchemaSpec.enforcedFieldSpecs.length > 0 ||
    enforcedSchemaSpec.enforcedConstraintSpec != null ||
    (enforcedSchemaSpec.enforcedNamingStrategySpec != null &&
      getShouldAddNamingStrategies(enforcedSchemaSpec.enforcedNamingStrategySpec, existingNamingStrategies))
  );
}
